import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeading from "@/components/base/SectionHeading";
import ContentCard from "@/components/base/ContentCard";
import CharacterCard from "@/components/base/CharacterCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import { getByType } from "@/lib/content";

const friendLinks = [
  "动漫剧情资料馆",
  "二次元角色研究所",
  "动画资讯速递",
  "家庭教师同好会",
  "番剧考据社",
];

export default function Home() {
  const animations = getByType("animation").slice(0, 3);
  const characters = getByType("character").slice(0, 4);
  const news = getByType("news").slice(0, 4);

  return (
    <SiteLayout>
      <HeroCarousel />

      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <section className="py-12 md:py-16">
          <SectionHeading
            kicker="内容导航"
            title="从三个方向走进「家庭教师」"
            description="无论你是第一次接触，还是已经追完全季，都能在这里找到合适的入口。"
          />
          <CategoryQuickLinks />
        </section>

        <section className="py-12 md:py-16">
          <SectionHeading
            kicker="剧情介绍"
            title="最新剧情介绍"
            description="按话数整理的剧情梳理，包含概要、亮点与伏笔解析。"
            action={
              <Link
                to="/category/animation"
                className="inline-flex items-center gap-1 rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            }
          />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {animations.map((item) => (
              <ContentCard key={item.id} item={item} />
            ))}
          </div>
        </section>

        <section className="py-12 md:py-16">
          <SectionHeading
            kicker="角色分析"
            title="热门角色解析推荐"
            description="从性格、动机到成长轨迹，看清每个角色在故事中的位置。"
            action={
              <Link
                to="/category/character"
                className="inline-flex items-center gap-1 rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            }
          />
          <div className="grid grid-cols-2 gap-5 lg:grid-cols-4">
            {characters.map((item) => (
              <CharacterCard key={item.id} item={item} />
            ))}
          </div>
        </section>

        <section className="py-12 md:py-16">
          <SectionHeading
            kicker="动漫资讯"
            title="最新动漫资讯动态"
            description="追踪「家庭教师」及相关动漫的最新消息、活动与访谈。"
            action={
              <Link
                to="/category/news"
                className="inline-flex items-center gap-1 rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            }
          />
          <div className="flex flex-col gap-4">
            {news.map((item) => (
              <ContentCard key={item.id} item={item} variant="horizontal" />
            ))}
          </div>
        </section>

        <section className="py-12 md:py-16">
          <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-secondary-50 p-6 md:grid-cols-3 md:p-10">
            <div className="md:col-span-2">
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                关于本站
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                「家庭教师」动画剧情介绍与角色解析平台，是一个面向广泛动漫爱好者的内容站点。
                我们以清晰的结构梳理剧情脉络，从多个维度解析角色，并持续追踪最新资讯，
                希望为每一位观众提供一份可以反复查阅的作品资料库。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-500">
                站内所有内容均为演示虚拟数据，用于展示信息结构与浏览体验，不涉及真实版权信息、评分或播放内容。
              </p>
              <Link
                to="/about"
                className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                了解我们的定位
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>
            <div>
              <h3 className="font-heading text-sm font-bold text-foreground-950">友情链接</h3>
              <ul className="mt-4 grid grid-cols-1 gap-2.5">
                {friendLinks.map((name) => (
                  <li key={name}>
                    <a
                      href="#"
                      rel="nofollow"
                      className="flex items-center gap-2 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      <i className="ri-link" aria-hidden="true" />
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}